module.exports = __webpack_public_path__ + "static/media/strawberry.f9b9e05f.png";